// @flow
import Immutable from "seamless-immutable";
import createReducer from "common/reducerBase";
import { types as rootAts } from "root/actions";

import CropRecord from "../data/CropRecord";

const clearCropState = (state: Immutable) => {
	const record = CropRecord();
	return state
		.set("cropSources", record.cropSources)
		.set("crop", record.crop);
};

export default {
	cropWidget: createReducer(CropRecord(), {
		[rootAts.SET_UPLOADER_CROP_SOURCES]: (state: Immutable, { payload }) => state.set("cropSources", payload),

		[rootAts.SET_DEFAULT_CROP]: (state: Immutable, { payload }) => state.set("defaultCrop", payload),

		[rootAts.SET_CROP]: (state: Immutable, { payload }) => state.set("crop", payload),

		[rootAts.CLEAR_QUEUE]: clearCropState,

		[rootAts.SET_BATCH_STARTED]: clearCropState,
	}),
};
